import { createFileRoute } from '@tanstack/react-router';
import { ProductosPage } from '@/components/marketing/ProductosPage';
import { MarketingShell } from '@/components/marketing/MarketingShell';

/**
 * `/productos` — Slice G. Sticky pill nav + 5 productos.
 */
export const Route = createFileRoute('/_public/productos')({
  component: ProductosRoute,
});

function ProductosRoute(): JSX.Element {
  return (
    <MarketingShell currentPath="/productos">
      <ProductosPage />
    </MarketingShell>
  );
}
